export default
{
	icons: [
		{
			name: "blinds",
			x: 1142,
			y: 315
		},
		{
			name: "clock",
			x: 1616,
			y: 83
		},
		{
			name: "whiteboard",
			x: 1728,
			y: 450.05
		},
		{
			name: "drip",
			x: 706,
			y: 329
		},
		{
			name: "breakfast",
			x: 313,
			y: 548.05
		},
		{
			name: "talk2pat",
			x: 523,
			y: 404.05
		},
		{
			name: "exit",
			x: 982,
			y: 950.05
		},
		{
			name: "zweedseBand",
			x: 667,
			y: 532.05
		},
		{
			name: "glasses",
			x: 352,
			y: 547
		},
		{
			name: "medication",
			x: 615,
			y: 466.5
		},
		{
			name: "water",
			x: 205.5,
			y: 539.55
		},
		{
			name: "cad",
			x: 534.95,
			y: 741
		}
	],
	objects: [
		{
			name: "clock",
			x: 1580.55,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1546,
			y: 537.75
		}
	]
}